import { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { FixedAssetDto } from "../../../../dtos/catalogs/fixedasset/FixedAssetDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import TransactionTable from "../../../Shared/NewForms/NFTable";
import FixedAssetDetailSkeleton from "./FixedAssetDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import FixedAssetDetailMain from "./FixedAssetDetailMain";
import FixedAssetDetailChief from "./FixedAssetDetailChief";
import FixedAssetDetailLocation from "./FixedAssetDetailLocation";
import FixedAssetDetailDepreciationParameters from "./FixedAssetDetailDepreciationParameters";
import FIxedAssetDetailAdditional from "./FIxedAssetDetailAdditional";

interface IProps {
  model: FixedAssetDto | null;
  modelUpdatedEvent: (newModel: FixedAssetDto) => void;
}

interface FixedAssetModel {
  id: string;
  name: string;
  code?: string;
  status?: string;
  description?: string;
  inventoryNumber?: string;
  fixedAssetsAccountingGroup?: string;
  releaseDate?: string;
  dateOfRecognition?: string;
  lifeTerm?: number;
  companyId?: string;
  departmentId?: string;
  address?: string;
  replacementCost?: number;
  accumulatedDepreciation?: number;
  netBookValue?: number;
  depreciationStartingDate?: Date;
  depreciationMethod?: number;
  salvageValue?: number;
  cost?: number;
  oneYearDepreciation?: number;
  lastAmortizationDate?: string;
  commissioningDate?: string;
  depreciation?: number;
  netValue?: number;
  group?: string;
  category?: string;
  purchaseDate?: string;
  purchaseValue?: number;
  accountingAccount?: number;
  depreciationAccount?: number;
  expensesAccount?: number;
}

export const FixedAssetDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const status = [
    { id: 0, name: "Not active" },
    { id: 1, name: "Active" },
    { id: 2, name: "Written off" }
  ];

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<FixedAssetModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("status", model.status);
      setValue("description", model.description);
      setValue("inventoryNumber", model.inventoryNumber);
      setValue("fixedAssetsAccountingGroup", model.fixedAssetsAccountingGroup);
      setValue("releaseDate", model.releaseDate);
      setValue("dateOfRecognition", model.dateOfRecognition);
      setValue("lifeTerm", model.lifeTerm);
      setValue("companyId", model.companyId);
      setValue("departmentId", model.departmentId);
      setValue("address", model.address);
      setValue("replacementCost", model.replacementCost);
      setValue("accumulatedDepreciation", model.accumulatedDepreciation);
      setValue("netBookValue", model.netBookValue);
      setValue("depreciationStartingDate", model.depreciationStartingDate);
      setValue("depreciationMethod", model.depreciationMethod);
      setValue("salvageValue", model.salvageValue);
      setValue("cost", model.cost);
      setValue("oneYearDepreciation", model.oneYearDepreciation);
      setValue("lastAmortizationDate", model.lastAmortizationDate);
      setValue("commissioningDate", model.commissioningDate);
      setValue("depreciation", model.depreciation);
      setValue("netValue", model.netValue);
      setValue("group", model.group);
      setValue("category", model.category);
      setValue("purchaseDate", model.purchaseDate);
      setValue("purchaseValue", model.purchaseValue);
      setValue("accountingAccount", model.accountingAccount);
      setValue("depreciationAccount", model.depreciationAccount);
      setValue("expensesAccount", model.expensesAccount);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: FixedAssetModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: FixedAssetDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
  };

  const tabsChangeHandler = (index: number) => {
    setTabIndex(index);
  };

  if (!model) {
    return (
      <>
        <FixedAssetDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Chief"} />
          <NFTab title={"Location"} />
          <NFTab title={" Depreciation Parameters"} />
          <NFTab title={"Additional"} />
          <NFTab title={"Transaction"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <FixedAssetDetailMain />
        </NFTabContainer>
        {/*  */}
        <NFTabContainer index={1} currentIndex={tabIndex}>
          <FixedAssetDetailChief />
        </NFTabContainer>
        {/*  */}

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <FixedAssetDetailLocation />
        </NFTabContainer>
        {/*  */}
        <NFTabContainer index={3} currentIndex={tabIndex}>
          <FixedAssetDetailDepreciationParameters />
        </NFTabContainer>
        {/*  */}
        <NFTabContainer index={4} currentIndex={tabIndex}>
          <FIxedAssetDetailAdditional />
        </NFTabContainer>

        <NFTabContainer index={4} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <TransactionTable />
            </Col>
          </Row>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
